<template>
  <div @mouseenter="mouseHandler(true)" @mouseleave="mouseHandler(false)">
    <v-text-field
      id="quickSearch"
      label="Search"
      autocomplete="off"
      rounded
      dense
      hide-details
      single-line
      filled
      :background-color="backgroundColor"
      :style="styleChanger"
      prepend-inner-icon="search"
      @input="updateSearchTerm($event)"
      @focus="
        initSearch({});
        toggleShowQuickSearch(true);
        focusThemeHandler(true);
      "
      @blur="
        quickSearchBlurHandler();
        focusThemeHandler(false);
      "
      v-on:keyup.enter="
        toggleShowSearch(true);
        toggleShowQuickSearch(false);
      "
      v-on:keyup.esc="storedSearchTerm = ''"
      :value="storedSearchTerm"
    ></v-text-field>
    <v-list class="pb-0" v-if="showQuickSearch" style="z-index:10; position:absolute;">
      <v-list-item
        v-if="storedSearchTerm.length > 2"
        @click="
          toggleShowSearch(true);
          toggleShowQuickSearch(false);
        "
        class="elevation-1"
      >
        <v-icon>search</v-icon>
        <v-list-item-content class="ml-2">
          <v-list-item-subtitle class="text--primary" v-text="sub1"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text v-text="actionText"></v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
      <search-result-tree-card
        v-for="result in searchResults"
        :key="result.id"
        :result="result"
        style="width: 800px"
        class="mb-1"
      ></search-result-tree-card>
    </v-list>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import useSearch from '@/views/Context/use/useSearch';
import SearchResult from './SearchResult.vue';
import SearchResultTreeCard from './SearchResultTreeCard.vue';

export default {
  components: { SearchResult, SearchResultTreeCard },

  setup(props) {
    const {
      showSearch,
      showQuickSearch,
      // storedResults,
      searchResults,
      initSearch,
      toggleShowSearch,
      toggleShowQuickSearch,
      updateSearchTerm,
      storedSearchTerm
    } = useSearch();
    const search = ref('');
    const mouseInside = ref(false);
    const backgroundColor = ref('#FFFFFF');
    const styleChanger = ref('z-index:1; transition:0.2s all ease 0.1s; max-width:200px');

    const sub1 = computed(() => {
      console.log('results!', searchResults, typeof searchResults.value);
      if (typeof searchResults.value == 'undefined' || searchResults.value.length == 0) {
        return 'no results';
      } else {
        return searchResults.value.length + ' results';
      }
    });
    const actionText = ref('ENTER FOR MORE');

    const focusThemeHandler = focused => {
      if (focused) {
        backgroundColor.value = '#E3F2FD';
        styleChanger.value = 'z-index:1; transition:0.2s all ease 0.1; max-width:800px';
      } else {
        backgroundColor.value = '#FFFFFF';
        styleChanger.value = 'z-index:1; transition:0.2s all  ease 0.1s; max-width:200px';
      }
    };

    function mouseHandler(value) {
      mouseInside.value = value;
    }

    function quickSearchBlurHandler() {
      if (!mouseInside.value) {
        toggleShowQuickSearch(false);
      }
    }

    // const searchResults = computed(() => {
    //   console.log('searching', search);

    //   if (search.value && search.value.length > 2) {
    //     return fuseSearch(search.value);
    //   } else {
    //     return [];
    //   }
    // });
    const items = [{ title: search.value }, { title: 'how about this?' }];
    return {
      styleChanger,
      focusThemeHandler,
      backgroundColor,
      sub1,
      actionText,
      mouseHandler,
      mouseInside,
      quickSearchBlurHandler,
      showSearch,
      showQuickSearch,
      items,
      search,
      toggleShowSearch,
      toggleShowQuickSearch,
      initSearch,
      updateSearchTerm,
      storedSearchTerm,
      // storedResults,
      searchResults
    };
  }
};
</script>

<style>
.v-list {
  /* height: 1000px; or any height you want */
  overflow-y: auto;
}
.result-list {
  height: 1000px; /* or any height you want */
  overflow-y: auto;
}
</style>
